import styled from "styled-components";

export const StyledEventBlockWrapper = styled.div``;
